






























import {Component, Prop, Mixins} from 'vue-property-decorator'
import {onLoadJumpMixin} from '@/mixins/onScrollAnimationMixin'
import ContactForm from '@/components/contact/ContactForm.vue'

@Component({
  components: {
    ContactForm
  }
})

export default class OutsideView extends Mixins(onLoadJumpMixin) {
  @Prop() readonly subtitle?: string
  @Prop() readonly title?: string
  @Prop({ default: false }) readonly withForm?: boolean
   className: string = ''
  mounted() {
    if (this.$route.path === '/team-content') {
      this.className = 'team'
    } 
  }
}
